import React from 'react';


import Footer from './Component/Footer/Footer';
import NavBar from './Component/Navbar/navBar';
import MainContent from './Component/MainContent/MainContent';

import './App.less';

function App() {
  return (
    <div className="App">
      <header>
        <NavBar />
      </header>
      <main>
        <MainContent />
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
